module.exports = __webpack_public_path__ + "img/肉苁蓉.a2c2c1c0.jpg";